import layout from '@/layout'

export default {
  path: '/shareholders',
  component: layout,
  redirect: '/shareholders/all',
  name: 'shareholdersAll',
  meta: {
    title: 'shareholders',
    icon: 'shareholders'
  },
  children: [
    {
      path: '/shareholders/all',
      name: 'shareholdersAll',
      component: () => import('@/views/shareholders/all'),
      meta: {
        title: 'shareholdersAll',
        icon: 'shareholders'
      }
    }
  ]
}
